
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/our-favourite-local-businesses",
      function () {
        return require("private-next-pages/blog/our-favourite-local-businesses.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blog/our-favourite-local-businesses"])
      });
    }
  